<template>
    <div>
        <loading-block v-if="dataIsLoading"></loading-block>
        <section v-else>
            <div>
                <h1>Professeurs</h1>
                <uni-button @click.native="showSectionAddAdmin = true">Créer un professeur</uni-button>
            </div>

            <div>
                <!--                <admin-inline v-for="user in users" :user="user"-->
                <!--                              :family="families.find(el => el.id === user.family_id)"></admin-inline>-->
            </div>
            <!--        <user-inline v-for="user in users" :user="user"></user-inline>-->
        </section>
        <pop-from-bottom :open="showSectionAddAdmin"
                         title="Ajout d'un administrateur"
                         @close="showSectionAddAdmin = false"
        >
            <template slot="content">
                <ValidationObserver ref="addRespObserver"
                                    v-slot="{ invalid }"
                                    tag="form"
                                    @submit.prevent="submitANewAdmin()"
                >
                    <duo-input>
                        <uni-input-container label="Prénom" for="firstname">
                            <uni-input rules="alpha_dash|required"
                                       v-model="newAdmin.firstname"
                                       id="firstname"
                            />
                        </uni-input-container>

                        <uni-input-container label="Nom">
                            <uni-input rules="alpha_dash|required"
                                       v-model="newAdmin.name"
                                       id="name"
                            />
                        </uni-input-container>
                    </duo-input>

                    <uni-input-container label="Adresse e-mail" for="email">

                        <uni-input rules="required|email"
                                   v-model="newAdmin.email"
                                   id="email"
                        />
                    </uni-input-container>
                    <uni-input-container label="Téléphone"
                                         for="tel"
                    >
                        <uni-input rules="required|digits:10"
                                   v-model="newAdmin.tel"
                                   id="tel"
                        />
                    </uni-input-container>
                    <uni-input-container label="Rôle de l'administrateur">
                        <uni-input-radio label="Super Administrateur"
                                         id="superAdminRadioButton"
                                         style="margin-top:12px"
                        >
                            <input type="radio"
                                   v-model="newAdmin.role"
                                   id="superAdminRadioButton"
                                   value="superAdmin"
                            >
                        </uni-input-radio>

                        <uni-input-radio label="Éditeur"
                                         id="editorRadioButton"
                        >
                            <input type="radio"
                                   v-model="newAdmin.role"
                                   id="editorRadioButton"
                                   value="editor"
                            >
                        </uni-input-radio>

                        <uni-input-radio label="Lecteur"
                                         id="readerRadioButton"
                        >
                            <input type="radio"
                                   v-model="newAdmin.role"
                                   id="readerRadioButton"
                                   value="reader"
                            >
                        </uni-input-radio>
                    </uni-input-container>

                    <uni-button @click.native="createNewResp">Ajouter l'administrateur</uni-button>
                </ValidationObserver>
            </template>
        </pop-from-bottom>
    </div>
</template>

<script>
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import UserInline from "../../components/b-patterns/userInline";
    import UniButton from "../../components/a-elements/UniButton";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
    import UniInputRadio from "../../components/a-elements/UniInputRadio";
    import DuoInput from "../../components/b-patterns/DuoInput";
    import AdminInline from "../../components/b-patterns/adminInline";

    export default {
        name: "adminProfessors",
        components: {
            AdminInline,
            DuoInput,
            UniInputRadio,
            RichYesNoInput,
            InputBirthday, UniInput, UniInputContainer, PopFromBottom, UniButton, UserInline, LoadingBlock
        },
        data() {
            return {
                users: [],
                families: [],
                dataIsLoading: false,
                showSectionAddAdmin: false,
                newAdmin: {
                    name: "",
                    firstname: "",
                    email: "",
                    tel: "",
                    is_dancer: false,
                    tel: "",
                    role: '',
                }
            }
        },
        methods: {
            submitANewAdmin() {
                // Add the magic sauce here
            }
        },
        async created() {
            // this.$adminGetDancers()
            //     .then(data => {
            //         this.users = data
            //         this.dataIsLoading = false
            //     })
            let response = await this.axios.get('/admin/admins')

            this.families = response.data

            response.data.forEach(el => {
                if (el.role !== 'dev')
                    this.users.push(el.users[0])
            })

            this.users = this.users.sort(this.$dynamicSort('name'))

        }
    }
</script>

<style scoped lang="scss">

    section {
        > div:first-child {
            margin-bottom: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

</style>
